import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../core/services/notification/notification.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransactionResult } from '../../../../../core/services/interfaces/transaction-result';
import { ISites } from '../../Interfaces/ISites';
import { SitesService } from '../../services/sites-services';
import { TranslateApplicationService } from '../../../../../core/translate/translate-application-service';
import { ActiveDirectoryService } from '../../services/activedirectory-services';
import { IEmployeesInActiveDirectory } from '../../Interfaces/IEmployeesInActiveDirectory';
import { ILanguages } from '../../Interfaces/ILanguages';
import { EmployeesService } from '../../services/employees-service';
import { IEmployees } from '../../Interfaces/IEmployees';
declare var jQuery: any;

@Component({
	selector: 'app-site-detail',
	templateUrl: './site-detail.component.html',
	styleUrls: ['./site-detail.component.scss'],
})
export class SiteDetailComponent {
	formGroup: FormGroup;
	loading = false;
	list: any[] = [
		{ Id: 1, Name: 'Nombre 1' },
		{ Id: 2, Name: 'Nombre 2' },
		{ Id: 3, Name: 'Nombre 3' },
	];

	listLenguage;
	max_characters_site: string;
	max_characters_code: string;
	max_characters_company: string;
	searching: boolean = false;
	searched: boolean = false;
  	isEditable: boolean = false;
	add_or_update: boolean = true; //add -> true - update -> false

	constructor(
		private dialogRef: MatDialogRef<SiteDetailComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ISites,
		private notificationService: NotificationService,
		private siteService: SitesService,
		private formBuilder: FormBuilder,
		public translate: TranslateApplicationService,
		private activeDirectoryService: ActiveDirectoryService,
		private employeeService: EmployeesService,
	) {
		this.formGroup = this.formBuilder.group({
			pksite: [data.pksite == null ? 0 : data.pksite],
			txtsite: [
				data.site == null ? '' : data.site,
				[
					Validators.required,
					Validators.maxLength(255),
					Validators.pattern('.*[a-zA-Z].*'),
				],
			],
			txtcode: [
				data.code == null ? '' : data.code,
				[
					Validators.required,
					Validators.maxLength(10),
					Validators.pattern('.*[a-zA-Z].*'),
				],
			],
			txtcompanyname: [
				data.companyname == null ? '' : data.companyname,
				[
					Validators.required,
					Validators.maxLength(255),
					Validators.pattern('.*[a-zA-Z].*'),
				],
			],
			cbtimezone: [data.timezone, Validators.required],
			cbfklanguage: [data.fklanguage, Validators.required],
			available: [data.available],
			pkemployee: [0],
			txtemployeename: [''],
			txtemployeenumber: [''],
			txtworkdayid: [''],
			txtusername: [''],
			txtemail: [''],
			txtposition: [''],
		});
	}

	ngOnInit(): void {
		let max_char = this.translate.TranslateKey('max_characteres');
		this.max_characters_site = max_char.replace('{{ number_max }}', '255');
		this.max_characters_code = max_char.replace('{{ number_max }}', '10');
		this.max_characters_company = max_char.replace('{{ number_max }}', '255');
		this.loading = true;
		jQuery('.cdk-overlay-pane').css('overflow', 'scroll');
		const component = this;
		component.GetTimeZone();
		jQuery('#inpEmployeeSerch').selectpicker();
		jQuery('.bs-searchbox').find('input').keyup(function () {
			if (
				jQuery(this).val().length >= 4 &&
				!component.searching &&
				!component.searched
			) {
				component.searching = true;
				jQuery('#inpEmployeeSerch').empty();
				jQuery('#inpEmployeeSerch').selectpicker('refresh');
				component.GetEmployeeByEmailNumberName(jQuery(this).val());
			}
			if (jQuery(this).val().length < 4) component.searched = false;
		});
		jQuery('#inpEmployeeSerch').change(function () {
			component.GetEmployeeByDistinguishedname(
				jQuery('#inpEmployeeSerch').val(),
			);
		});
		if (component.formGroup.controls.pksite.value == 0){
			jQuery('.inpEmployeeSerch').show();
			component.add_or_update = true;
		}
		else {
			jQuery('.inpEmployeeSerch').hide();
			component.add_or_update = false;
		}
		this.loading = false;
		if (this.formGroup.controls.pksite.value != 0) {
			// This for hide the user fields
			this.isEditable = true;
			// This is to make the form valid when editing
			this.formGroup.controls.available.setValue(true);
			this.formGroup.controls.pkemployee.setValue(true);
			this.formGroup.controls.txtemployeename.setValue(true);
			this.formGroup.controls.txtemployeenumber.setValue(true);
			this.formGroup.controls.txtworkdayid.setValue(true);
			this.formGroup.controls.txtusername.setValue(true);
			this.formGroup.controls.txtemail.setValue(true);
			this.formGroup.controls.txtposition.setValue(true);
		}
		this.GetLanguages();
	}

	Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message),
			shown: true,
		});
	}

	Close() {
		this.dialogRef.close(true);
	}

	ChangeEmployeeSearch(event) {
		jQuery('.p-dropdown').css('max-width', '250px');
		this.GetEmployeeByDistinguishedname(
			event.value.distinguishedname.toString(),
		);
	}
	
	CreateEmployee() {
		this.employeeService.CreateEmployee(this.formGroup.value).subscribe(
		(result: TransactionResult<boolean>) => {
			this.loading = false;
			if (result.success) {
				this.loading = true;
				this.employeeService.GetEmployeeByUserName(this.formGroup.controls.txtusername.value).subscribe(
				(result: TransactionResult<IEmployees[]>) => {
					this.loading = false;
					if (result.success) {
						this.formGroup.controls.pkemployee.setValue(result.data[0].pkemployee);
						this.CreateSite();
					}
					else{
						this.ErrorAlert(result.message);
					}
				},
				(error) => {
					this.ErrorAlert(error);
					this.loading = false;
				});
			} 
			else {
				this.Alert('Error', 'EMPLOYEES.Employee_not_added');
				this.loading = false;
			}
		},
		(error) => {
			this.ErrorAlert(error);
			this.loading = false;
		});
	}

	CreateSite() {
    	this.loading = true;
		this.siteService.CreateSite(this.formGroup.value).subscribe(
		(result: TransactionResult<ISites[]>) => {
			this.loading = false;
			if (result.success) {
				this.loading = true;
				this.formGroup.controls.pksite.setValue(result.data[0].pksite);
				// Set the admin role and site of the user
				this.employeeService.SetEmployeeDefaultAdminRole(this.formGroup.value).subscribe(
				(result: TransactionResult<boolean>) => {
					this.loading = false;
					if (result.success) {
						this.Alert('Success', 'COMPLETE');
						jQuery('.btnReloadSites').click();
						this.dialogRef.close(true);
					}
					else{
						this.ErrorAlert(result.message);
					}
				},
				(error) => {
					this.ErrorAlert(error);
					this.loading = false;
				});
			}
			else{
				this.ErrorAlert(result.message);
				this.loading = false;
			}
		},
		(error) => {
			this.Alert('Error', 'SITE.SITE_ALREADY_EXISTS');
			this.loading = false;
		});
	}

	GetEmployeeByDistinguishedname(value: string) {
    this.loading = true;
    var arr: IEmployeesInActiveDirectory[] = [];
		this.activeDirectoryService.GetEmployeeByDistinguishedname(value).subscribe(
		(result: TransactionResult<IEmployeesInActiveDirectory[]>) => {
			this.loading = false;
			if (result.success) {
				var jsonObj = JSON.parse(result.data.toString());
				arr = jsonObj.data;
				this.formGroup.controls.txtemployeename.setValue(arr[0].name);
				this.formGroup.controls.txtemployeenumber.setValue(arr[0].employeeNumber);
				this.formGroup.controls.txtworkdayid.setValue(arr[0].workdayId);
				this.formGroup.controls.txtusername.setValue(arr[0].userName);
				this.formGroup.controls.txtemail.setValue(arr[0].email);
				this.formGroup.controls.txtposition.setValue(arr[0].position);
			}
			else{
				this.ErrorAlert(result.message);
			}
		},
		(error: any) => { 
			this.ErrorAlert(error); this.loading = false; 
		});
	}

	GetEmployeeByEmailNumberName(value: string) {
		this.loading = true;
		var arr: IEmployeesInActiveDirectory[] = [];
		this.activeDirectoryService.GetEmployeeByEmailNumberName(value).subscribe(
			(result: TransactionResult<IEmployeesInActiveDirectory[]>) => {
				this.loading = false;
				this.searching = false;
				this.searched = true;

				if (result.success) {
					var jsonObj = JSON.parse(result.data.toString());
					arr = jsonObj.data;
					jsonObj.data.name;

					arr.forEach((obj) => {
						jQuery('#inpEmployeeSerch').append(
							'<option value="' +
								obj.distinguishedname +
								'">' +
								obj.name +
								'</option >',
						);
					});
					jQuery('#inpEmployeeSerch').selectpicker('refresh');
					jQuery('#inpEmployeeSerch').change();
				}
				else{
					this.ErrorAlert(result.message);
				}
			},
			(error: any) => {
				this.ErrorAlert(error);
				this.loading = false;
			},
		);
	}

	GetEmployeeByUserName() {
		this.employeeService.GetEmployeeByUserName(this.formGroup.controls.txtusername.value).subscribe(
		(result: TransactionResult<IEmployees[]>) => {
			if (result.success) {
				if (result.data.length == 0) {
					this.CreateEmployee();
				} else {
					this.formGroup.controls.pkemployee.setValue(result.data[0].pkemployee);
					this.UpdateEmployee();
				}
			}
			else{
				this.ErrorAlert(result.message);
			}
		},
		(error: any) => { 
			this.ErrorAlert(error); this.loading = false; 
		});
	}

  	GetLanguages() {
    	this.loading = true;
		this.siteService.GetLanguages().subscribe(
		(result1: TransactionResult<ILanguages[]>) => {
			this.loading = false;
        	if (result1.success) {
				this.listLenguage = result1.data;
			}
			else{
				this.ErrorAlert(result1.message);
			}
		},
		(error: any) => { 
			this.ErrorAlert(error); 
			this.loading = false;
		});
	}

	GetTimeZone() {
		this.loading = true;
		this.siteService.GetTimeZones().subscribe(
		(result1: TransactionResult<ISites[]>) => {
			this.loading = false;
			if (result1.success) {
				this.list = result1.data;
			}
			else{
				this.ErrorAlert(result1.message);
			}
		},
		(error: any) => { 
			this.ErrorAlert(error); 
			this.loading = false;
		});
	}

	Save() {
		this.loading = true;
		// New site
		if (this.formGroup.controls.pksite.value == 0) {
			// Validate form
			if (
				this.formGroup.valid &&
				this.formGroup.controls.txtemployeename.value != '' &&
				this.formGroup.controls.txtemployeenumber.value != '' &&
				this.formGroup.controls.txtworkdayid.value != '' &&
				this.formGroup.controls.txtusername.value != '' &&
				this.formGroup.controls.txtemail.value != '' &&
				this.formGroup.controls.txtposition.value != ''
			) {
				this.GetEmployeeByUserName();
				this.loading = false;
			} else {
				this.loading = false;
				this.Alert('Warning', 'COMPLETE_FORM');
			}
		} else {
			// Update site
			this.UpdateSite();
			this.loading = false;
		}
	}

	UpdateEmployee() {
		this.loading = true;
		this.employeeService.UpdateEmployee(this.formGroup.value).subscribe(
		(result: TransactionResult<boolean>) => {
			this.loading = false;
			if (result.success) {
				this.CreateSite();
			}
			else{
				this.ErrorAlert(result.message);
			}
		},
		(error) => {
			this.ErrorAlert(error);
			this.loading = false;
		});
	}

	UpdateSite() {
		this.loading = true;
		this.formGroup.controls.available.setValue(this.data.available);
		this.siteService.UpdateSite(this.formGroup.value).subscribe(
		(result: TransactionResult<boolean>) => {
			this.loading = false;
			if (result.data) {
				this.Alert('Success', 'COMPLETE');
				jQuery('.btnReloadSites').click();
				this.dialogRef.close(true);
			}
			else{
				this.ErrorAlert(result.message);
			}
		},
		(error) => {
			this.Alert('Error', 'SITE.SITE_ALREADY_EXISTS');
			this.loading = false;
		});
	}

	ErrorAlert(message: any) {
		this.notificationService.AddAlert({
		  icon: 'all_inbox',
		  title: 'Error',
		  message: message,
		  shown: true,
		});
	}
}
